<template>
  <div class="">

    <nav class="nav-extended blue-nav">
      <div class="nav-wrapper">
        <a class="active btn blue" href="/tutorials">&lt; Back</a> &nbsp; &nbsp;
        <span class="nav-title">
          Edit Tutorial

        </span>
        <div class="switch" @click="updatePublished()">
          <label>
            Unpublished
            <input type="checkbox" id="tutorial_publish" v-model="published" >
            <span class="lever"></span>
            Publish
          </label>
        </div>
      </div>
      <div class="nav-content ">
      </div>
    </nav>
    <div class="row" id="title-container" style="">
      <div class="col s10 offset-s1 offset-m1 offset-l1">
        <span class="flow-text">
          <span id="contentTitle" class="tutorial-title">{{title}}</span>
        </span>
      </div>
    </div>
    <div class="row" id="description-container" style="">
      <div class="col s10 m6 l6 offset-s1 offset-m1 offset-l1">
        <span class="flow-text">
          <span id="contentDescription" class="tutorial-description">{{description}}</span>
        </span>
      </div>
    </div>

    <div class="row">
      <div id="playercolumn" class="col s12 m5 l5 offset-m1 offset-l1 ">

        <div id="player"></div>
        <br />
        <div id="test-slider"></div>
        <br /> <br />

        <Steps
        v-if="steps && steps.length > 0"
        :steps="steps"
        :current_step="current_step"
        :step_click="selectStep"
        :editing="true"
        :edit_click="editStep"
        :delete_click="deleteStep" />


      </div>
      <div class="col s12 m5 l5">
        <div class="steps-gradient">
          <div id="transer">
            <div v-if="hasVideo">
              <ul id="transcript" class="steps collapsible" data-collapsible="accordion">
                <li  class="step active" >
                  <div class='collapsible-header active' >
                    <div :class="{barLeft: true, active: true}">
                      <p class="section-number" v-if="edit_step">{{edit_step+1}}</p>
                      <div class="section-title input-field col s12">
                        <input id="newStepTitle" type="text" data-length="10" v-model='new_step_title'/>
                        <label for="newStepTitle">Step title</label>
                      </div>
                    </div>
                  </div>
                  <div class='collapsible-body'>

                    <div class="input-field col s12">
                      <textarea id="newStepDescription" class="editable medium-editor-textarea" data-length="120" placeholder="Step Description" v-model="new_step_description"></textarea>
                      <br><br>
                    </div>
                    <div class="row">
                      <div v-if="!(parseInt(edit_step) >= 0)" id="createstep" class="col s12 center"><a id="syncher" class="waves-effect waves-light btn gray" @click="synchClick()"><i class="material-icons left">autorenew</i>Sync to Video</a></div>
                      <div v-if="typeof(edit_step) == 'number'" id="updatestep" class="col s12 center"><a id="syncupdate" class="waves-effect waves-light btn gray" @click="updateStep()">Update Step</a></div>
                    </div>
                  </div>
                </li>
                <li style="visibility:hidden">
                  <div style="height:375px;overflow:auto;padding-right:17px;box-sizing:content-box;"></div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// delete error:
// "ExpressionAttributeValues must not be empty"

import Sidebar from '@/components/Sidebar'
import Steps from '@/components/Steps'
import cognitoAuth from '@/plugins/cognito'
import GqlQuery from '@/plugins/gql'

let apiGPrefix = process.env.GQL_ENDPOINT;
apiGPrefix = apiGPrefix.replace("gql","")
const axios = require('axios');
var slugify = function(text_to_slugify){
  return text_to_slugify
  .toLowerCase()
  .replace(/[^\w ]+/g,'')
  .replace(/ +/g,'-')
  ;
}
export default {

  updated() {
    let self = this
    M.AutoInit();
    $('.collapsible-header.active').on('click', (e) => e.stopPropagation())
  },

  mounted() {
    let self = this
    cognitoAuth.getIdToken(function(err, jwttoken) {
      // todo error handler
      self.token = jwttoken
    })
    this.loadTutorial()

    M.AutoInit();

  },

  name: 'NewTemplate',
  data () {
    return {
      title: "",
      tutorial: {},
      description: "",
      steps: [],
      video_url: null,
      browser_title: '',
      id: this.$route.params.id,
      time_to_complete: '',
      current_step: false,
      edit_step: false,
      token: false,
      slider: false,
      video_duration: 0,
      new_step_title: '',
      new_step_description: '',
      published: false,
      posted_at: false,
      timeToComplete: [
        "1 MINUTE", "2 MINUTES", "3 MINUTES", "4 MINUTES", "5 MINUTES", "10 MINUTES",
        "15 MINUTES", "30 MINUTES", "60+ MINUTES"
      ]
    }
  },

  computed: {
    hasVideo: function() {
      return this.video_url !== null && this.video_url.length > 5
    }
  },


  methods : {
    loadTutorial () {
      let self = this
      GqlQuery.getTutorial(this.id, "en", function(err, response) {
        if (err) {
          self.error = err;
        } else {

        }
        response.json().then(function(val) {
          var tutorial = val.data.chapter
          if (val && val.data && val.data.chapter) {
            self.edit_step = false
            self.new_step_title = ''
            self.new_step_description = ''
            self.tutorial = tutorial
            self.title = tutorial.title.replace(/-/g, ' ')
            self.browser_title = tutorial.browser_title.replace(/-/g, ' ')
            self.description = tutorial.description
            self.steps = tutorial.steps
            self.video_url = tutorial.raw_url
            self.article_id = tutorial.article_id
            self.published = tutorial.published
            self.posted_at = tutorial.posted_at
            if (!self.hasVideo) {
              self.setUpDropzone()
            } else {
              $("#player").removeClass("dropzone");
              $("#player").empty();
              self.setUpVideo()
              setTimeout(()=>{
                self.setUpEditor()

              }, 500)

            }
          }
        })
      })
    },

    setUpVideo(){
      let self = this

      jwplayer("player").setup({
        file: 'assets/120.mp4',
        mute: true,
        tracks: [
        ],
        displaytitle: false,
        width: "100%",
        aspectratio: "16:9"
      });

      jwplayer().load([{
        file: self.video_url,
      }])

      jwplayer().pause(true);

      let errorcount = 0
      jwplayer().on('error', function(err){
        if(errorcount>4){
          alert("There was a problem loading your video. Fyi.io support is looking into this.");
          return;
        }
        errorcount++;
        jwplayer().load([{
          file:  self.video_url
        }])
      });

      // Highlight current caption and chapter
      let initialPausePerformed=false;
      // var videoDuration
      jwplayer().on('time', function(e){
        if(e.position>=0 && e.position<=1.1 && initialPausePerformed==false){
          jwplayer().pause(true);
          initialPausePerformed=true;
        }
        if(e.duration>11 || self.hasVideo){//default loading video is duration 10
          if (self.video_duration == 0) {
            self.video_duration = Math.round(e.duration);
          }

          if(self.slider){
            /*DC 8/2 -was commented out
             if(!editingExistingStep){
               var valzer=slider.noUiSlider.get();
               var seeker=e.position;
               if(e.position<maxStep){
                 seeker=maxStep;
                 jwplayer().seek(seeker);
               }
               slider.noUiSlider.updateOptions({
                 start: [maxStep, Math.round(seeker)]
               });
             }
            */ 
             
          } else{
            console.log("setting up slider, if not inited")
            self.setUpSlider(Math.round(e.duration));
          }
        }
      });
    },

    setUpDropzone () {
      $("#player").addClass("dropzone");
      let self = this
      Dropzone.prototype.defaultOptions.dictDefaultMessage = "Drag your video here or click to upload";
      Dropzone.options.player = {
        acceptedFiles: ".mp4,.avi",
      }
      var myDropzone = new Dropzone("div#player",{
        url: '/', // Set the url
        method: 'PUT',
        maxFilesize: 10000,  //500mb limit
        timeout: 0,
        acceptedFiles: '.mp4,.avi',
        parallelUploads: 1,
        uploadMultiple: false,
        autoQueue: false,

        renameFile: function (file) {
          // not sure if active
          var filename = new Date().getTime() + '_' + file.name;
          return filename
        },
        success: function(file, res) {
          $("#player").removeClass("dropzone");
          $("#player").empty();
          M.toast({
            html:"The video was successfully uploaded and is being processed. You may create written steps while it is being prepared.",
            inDuration: 3000,
            completeCallback:  function(){self.loadTutorial()}
          });
        },
        error: function(file, res) {
          console.log('Upload error.');
        }
      });

      myDropzone.on("processing", function(file) {
        this.options.url = file.uploadURL;
      });

      // Update the total progress bar
      myDropzone.on("totaluploadprogress", function(progress) {
        console.log(progress);
        //  document.querySelector("#total-progress .progress-bar").style.width = progress + "%";
      });

      myDropzone.on("addedfile", function(file) {
        let token = self.token
        let posted = self.tutorial.posted_at
        var instance = axios.create({

        });
        var tutorialName=slugify($("#contentTitle").text());
        //var filepath=`videos-raw/${namespace}/` + file.name;
        let namespace = self.tutorial.organization.name
        instance.defaults.headers.common['Authorization'] = token;
        let postedFileName = new Date().getTime() + '_' +file.name;
        axios.post(`${apiGPrefix}prepare-upload`, {
          fileName: postedFileName,
          contentType: file.type,
          namespace: namespace,
          tutorial: slugify(self.title),
          article_id: self.article_id,
          posted_at: posted
        })
        .then(function (response) {
          var urlSave=response.data;
          file.uploadURL=urlSave;
          myDropzone.enqueueFile(file)
        })
        .catch(function (error) {
          console.log(error);
        });

      });

      myDropzone.on("sending", function(file, xhr) {
        let _send = xhr.send
        xhr.send = () => {
          _send.call(xhr, file)
        }
      });
    },

    setUpSlider (maxxer) {
      let self = this
      let slider = document.getElementById('test-slider');
      noUiSlider.create(slider, {
        start: [0,0],
        tooltips: [wNumb({ decimals: 1 }), wNumb({ decimals: 1 }) ],
        step: 1,
        connect: true,
        orientation: 'horizontal', // 'horizontal' or 'vertical'
        range: {
          'min': [  0 ],
          '30%': [  30 ],
          'max': [ maxxer ]
        },
        format: wNumb({
          decimals: 1
        }),
        pips: { mode: 'count', values: 5, density: 5 }
      });
      var origins = slider.getElementsByClassName('noUi-origin');

      if (this.steps.length > 0) {
        let last_step = this.steps[this.steps.length-1]
        slider.noUiSlider.updateOptions({
          start: [parseFloat(last_step.end_time), parseFloat(last_step.end_time)+1]
        });
      }

      origins[0].setAttribute('disabled', true);
      slider.noUiSlider.on('slide', function(values, handle, unencodedValues ){
        // there's some strange behavior here, the player wouldn't pause or seek correctly,
        // even though this function was clearly called.
        // added a couple settimeouts to ensure the video is at the right place and paused.
        var position=values[handle];
        jwplayer().seek(position);
        jwplayer().pause(true);
        setTimeout(function(){
          jwplayer().seek(position);
          jwplayer().pause(true);
        }, 100)
        setTimeout(function(){
          jwplayer().pause(true);
        }, 200)
      });
      self.slider = slider
    },

    setUpEditor() {
      if (this.editor) {
        this.editor.destroy()
      }
      this.editor = new MediumEditor('.editable',{
        placeholder:false,
        buttonLabels: 'fontawesome',
        autoLink:true,
        targetBlank:true,
        placeholder: {
          text: 'Step Description',
          hideOnClick: true
        },
        toolbar: {
          buttons: ['bold', 'italic', 'underline', 'anchor', 'orderedlist', 'unorderedlist','pre'],
        }
      });
    },

    synchClick () {
      let self = this
      var valzer=self.slider.noUiSlider.get();

      let variables = {
        chapter_id: self.id,
        title: self.new_step_title,
        description: document.getElementById('newStepDescription').value,
        start_time: valzer[0],
        end_time: valzer[1]
      }

      GqlQuery.newStep(variables, (err, result) => {
        if (err) {
          this.error = err
        } else {
          self.loadTutorial()
          self.edit_step=false
          M.toast({
            html:"<span>Step created</span>",
            inDuration: 3000,
          });

          let end_time = result.data.createStep.end_time
          self.slider.noUiSlider.updateOptions({
            start: [parseFloat(end_time), parseFloat(end_time)+1]
          });
        }
      })

    },

    nextClick () {
      let variables = {
        title: this.title,
        description: this.description,
        article_id: this.article_id,
        time_to_complete: this.time_to_complete
      }
      GqlQuery.newTutorial(variables, (err, result) => {
        if (err) {
          this.error = err
        } else {
          window.location = "/tutorials/describe/" +result.data.id
        }
      })
    },

    editStep (index) {
      this.new_step_title = this.steps[index].title
      this.editor.destroy()
      this.new_step_description = this.steps[index].description
      $('#newStepDescription').val(this.new_step_description)
      $('#newStepTitle').trigger('focus')
      this.setUpEditor()
      this.edit_step = index
    },

/*
    selectStep (index) {
      console.log("Hello from Build selectStep");
      comsole.log("Index is ", index)
      this.current_step = index
      let step = this.steps[index]
      this.slider.noUiSlider.updateOptions({
        start: [parseFloat(step.start_time), parseFloat(step.end_time)]
      });
      var origins = this.slider.getElementsByClassName('noUi-origin');
      origins[0].setAttribute('disabled', true);
      origins[1].setAttribute('disabled', true);
      jwplayer().seek(parseFloat(step.start_time));
      jwplayer().pause(true);
    },
*/
    deleteStep(i) {
      let self = this
      let id = this.steps[i].id
      GqlQuery.deleteStep({id: id, chapter_id: this.id}, (err, result) => {
        if (err) {
          this.error = err
        } else {
          if (result) {
            self.loadTutorial();
            M.toast({
              html:"<span>Step deleted!</span>",
              inDuration: 1000
            });
          }
        }
      })
    },

    updateStep () {
      let self = this
      var valzer=self.slider.noUiSlider.get();

      let variables = {
        chapter_id: self.id,
        id: self.steps[self.edit_step].id,
        title: self.new_step_title,
        description: document.getElementById('newStepDescription').value,
        start_time: valzer[0],
        end_time: valzer[1]
      }

      GqlQuery.updateStep(variables, (err, result) => {
        if (err) {
          this.error = err
        } else {
          self.loadTutorial()
          M.toast({
            html:"<span>Step updated</span>",
            inDuration: 3000,
          });
        }
      })

    },

    updatePublished() {
      let self = this
      let variables = {
        id: this.id,
        published: !this.published, // hack, should call function via watcher
        article_id: this.article_id,
        posted_at: this.posted_at
      }
      GqlQuery.updateChapterPublishStatus(variables, (err, result) => {
        if (err) {
          this.error = err
        } else {
          this.loadTutorial()
        }
      })
    },
  },
  components: {
    Sidebar, Steps
  }
}
</script>

<style scoped>
.tutorial-description {
  color: #58595B;
  font-family: Roboto;
  font-size: 20px;
  text-align: left !important;
  font-weight: 300!important;
}

.tutorial-title {
  color: #58595B;
  font-family: Roboto;
  font-size: 54px;
  font-weight: 300!important;
  text-align: left !important;
}

.dropzone {
  border: 2px dashed #0087F7;
  border-radius: 5px;
  background: white;
}

.barLeft {
  border-left: 50px solid #58595b;
}
.barLeft.active {
  border-left: 50px solid #27aae1;

}

.section-number {
  font-size: 24px;
  margin: 0 0 10px 0;
  width: auto;
  text-align: left;
  color: white!important;
  margin-left: -32px!important;
  float: left;

}

.section-title {
  font-family: Roboto !important;
  line-height: 1.5 !important;
  padding-left: 20px !important;
  padding-top: 0px !important;
  text-align: left !important;
  color: black;
  margin-top:  10px;

}
.collapsible-body {
  border-left: 50px solid #58595b;

  border-right-style: ridge !important;

}
.active .collapsible-body {
  border-left: 50px solid #27aae1;
}
.collapsible-body p, .collapsible-body {
  font-size: 11pt!important;
  width: auto;
  text-align: left;
  line-height: 20px;
  color: #58595B;
  font-family: Roboto;
}
.collapsible-header {


  border-bottom-style: ridge !important;
  border-right-style: ridge !important;
  border-bottom: none!important;
  height: 50px;

  font-size: 13pt !important;
  font-family: Roboto;
  line-height: 2 !important;
  padding: .0rem !important;
}
.collapsible {
  width: auto;
  font-size:16pt;
  height: 17px;
  z-index:27;
  box-shadow: none;
  border: none;
}
.collapsible > li {
  margin-bottom: 24px!important;
  border-left: 20px;
  border: 1px #ddd solid;

}
#transcript {
  max-width: 400px;
}
#transer {
  position: fixed
}

#transcript .collapsible-body {
  padding: 0;
}

.section-title label.active {
  margin-top: 10px;
}
.editable {
  border: none;
  outline: none;
  resize: none;
}
.switch {
  float: right;
  margin-right: 20px;
}
.switch label {
  color: black;
}
</style>
<style scoped>
.editable ul {
  list-style-type: disc !important;
  padding-left: 20px;

}
.editable ul li {
  list-style-type: disc !important;
}

.noUi-connect {
  background: #27aae1 !important;
}
</style>



// WEBPACK FOOTER //
// src/containers/dashboard/template/EditTutorial.vue